<div [ngClass]="NotifNoLeidas !== 0 ? 'notification-box' : 'notification-box-wa'" (click)="toggleNotificationMobile()">
  <app-feather-icons [icon]="'bell'"></app-feather-icons>
  <span class="badge badge-pill badge-primary">{{NotifNoLeidas}}</span>
</div>
<ul class="notification-dropdown onhover-show-div" [class.active]="openNotification">
  <li>
    <app-feather-icons [icon]="'bell'"></app-feather-icons>
    <h6 class="f-18 mb-0">Notificaciones</h6>
  </li>
  <li *ngIf="(Notificaciones !== undefined) && (Notificaciones.length == 0)">No se encuentran notificaciones para mostrar.</li>
  <li *ngFor="let notif of Notificaciones">
    <div class="d-flex">
      <div class="d-flex justify-content-center align-items-center pl-0">
        <i class="fa fa-circle-o mr-3 font-danger"></i>
      </div>
      <div class="flex-grow-1">
        <a href="javascript:void(0)" (click)="LeerNotif(notif)">
           {{ notif.Observacion.Titulo || notif.Observacion.titulo || 'Título no disponible'}}
        </a>
        <p>{{ notif.FechaNotificado || notif.FechaNotificacion }}</p>
      </div>
    </div>
  </li>
  <li>
    <a class="btn btn-primary" (click)="onNotificaciones()">Ver todas las Notificaciones</a>
  </li>
</ul>